<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="Camada_1" data-name="Camada 1" viewBox="0 0 500 500">
    <path class="cls-1" d="M250,5.74c65.57,0,118.72,53.15,118.72,118.72s-53.15,118.72-118.72,118.72-118.72-53.15-118.72-118.72S184.43,5.74,250,5.74ZM451.72,494.26H48.28v-12.83c0-111.41,90.32-201.72,201.72-201.72h0c111.41,0,201.72,90.32,201.72,201.72v12.83Z"/>
  </svg>
</template>

<script>
export default {
  name: 'ReportIcon'
}
</script>
